import React from 'react'
import { Popover, type PopoverProps, Stack } from '@mui/material'
import { ThemeProvider } from '@mui/system'

import { Button, Typography } from '~components/internal'
import { internalLightTheme } from '~createInternalTheme'
import { spacing } from '~tokens/internal'

export const ClearNegativeFeedbackPopover: React.FC<
  PopoverProps & {
    onConfirm: () => void
  }
> = ({ onClose, onConfirm, ...props }) => {
  return (
    <ThemeProvider theme={internalLightTheme}>
      <Popover
        onClose={onClose}
        {...props}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <Stack spacing={spacing.xs} sx={{ padding: spacing.xs }}>
          <Typography component='p' variant='h5'>
            Do you want to clear your feedback?
          </Typography>
          <Stack direction='row' spacing={spacing.xxs} sx={{ justifyContent: 'flex-end' }}>
            <Button variant='text' onClick={onConfirm}>
              Yes
            </Button>
            <Button autoFocus onClick={() => onClose?.({}, 'backdropClick')}>
              No
            </Button>
          </Stack>
        </Stack>
      </Popover>
    </ThemeProvider>
  )
}
